/**
 * 受講生の投稿の壁 (VoiceWall) の CSS。HP (apps/shegate-web) と適職診断の結果 (apps/client) が同じ文字列を使う。
 * 色と余白は置き場の側で変数に入れる。
 *   --vw-ink    札の枠の色 (既定 #14231A)
 *   --vw-text   札の字の色 (既定 --vw-ink)
 *   --vw-card   札の地 (既定 #fff)
 *   --vw-sub    ハンドルと日付の灰 (既定 #5b5b55)
 *   --vw-line   アイコン無しの丸の枠 (既定 #d9d9d9)
 *   --vw-soft   アイコンの読み込み前の地 (既定 #fbf6ec)
 *   --vw-hover  乗せたときの枠の色 (既定 #1f56d6)
 *   --vw-focus  キーボードの枠 (既定 --vw-ink)
 *   --vw-mono   日付の字体
 *   --vw-bleed  壁の左右を、本文の外へ伸ばす量 (既定 0)。HP は本文の余白ぶん
 *   --vw-logo-filter  X と note の印に掛ける filter (暗い地で明るく返すときに使う。既定 none)
 * 動きを減らす設定では流さず、1 回分だけを指で横に送れる列にする。乗せても止めない (代表の指示)。キーボードのフォーカスがある間だけ止まる。
 */
export const VOICE_WALL_CSS = `
@keyframes vw-l{from{transform:translateX(0)}to{transform:translateX(-50%)}}
@keyframes vw-r{from{transform:translateX(-50%)}to{transform:translateX(0)}}
.vw-wall{display:grid;gap:12px;margin:0 calc(-1 * var(--vw-bleed,0px));-webkit-mask-image:linear-gradient(90deg,transparent,#000 20px,#000 calc(100% - 20px),transparent);mask-image:linear-gradient(90deg,transparent,#000 20px,#000 calc(100% - 20px),transparent)}
.vw-row{overflow:hidden;padding:2px 0 4px}
.vw-track{display:flex;align-items:flex-start;width:max-content;margin:0;padding:0;list-style:none;animation:vw-l var(--wall-dur,60s) linear infinite}
.vw-rev{animation-name:vw-r}
.vw-row:focus-within .vw-track{animation-play-state:paused}
.vw-track>li{flex:none;width:280px;margin-right:12px}
.vw-c{position:relative;display:flex;flex-direction:column;gap:10px;padding:14px 14px 12px;border:1px solid var(--vw-ink,#14231a);border-radius:6px;background:var(--vw-card,#fff);color:var(--vw-text,var(--vw-ink,#14231a));text-decoration:none}
.vw-c:hover{border-color:var(--vw-hover,#1f56d6)}
.vw-c:focus-visible{outline:2px solid var(--vw-focus,var(--vw-ink,#14231a));outline-offset:-2px}
.vw-c-hd{display:grid;grid-template-columns:40px minmax(0,1fr) auto;grid-template-areas:"av name logo" "av sub sub";align-items:start;column-gap:10px;row-gap:1px}
.vw-c-av{grid-area:av;width:40px;height:40px;border-radius:50%;object-fit:cover;background:var(--vw-soft,#fbf6ec)}
.vw-c-av-none{display:flex;align-items:center;justify-content:center;border:1px solid var(--vw-line,#d9d9d9);color:var(--vw-sub,#5b5b55);font-size:15px;font-weight:700}
.vw-c-name{grid-area:name;padding-top:1px;font-size:13px;font-weight:700;line-height:1.45;word-break:auto-phrase;text-wrap:pretty;overflow-wrap:anywhere}
.vw-c-sub{grid-area:sub;min-width:0;font-size:12px;line-height:1.5;color:var(--vw-sub,#5b5b55);overflow-wrap:anywhere}
.vw-c-logo{grid-area:logo;display:block;margin-top:4px;filter:var(--vw-logo-filter,none)}
.vw-c-logo-x{width:14px;height:14px}
.vw-c-logo-note{width:40px;height:15px}
.vw-c-tx{display:-webkit-box;-webkit-box-orient:vertical;font-size:13px;line-height:1.75;white-space:pre-line;word-break:auto-phrase;overflow-wrap:anywhere}
.vw-c-date{--font-body-ja:var(--vw-mono,ui-monospace,monospace);font-family:var(--vw-mono,ui-monospace,monospace);font-size:12px;font-weight:600;line-height:1.4;letter-spacing:.02em;color:var(--vw-sub,#5b5b55);font-variant-numeric:tabular-nums}
@media (prefers-reduced-motion:reduce){
  .vw-wall{-webkit-mask-image:none;mask-image:none}
  .vw-row{overflow-x:auto;overscroll-behavior-x:contain;scroll-snap-type:x mandatory;scroll-padding-left:var(--vw-bleed,0px);padding-left:var(--vw-bleed,0px);padding-right:var(--vw-bleed,0px);scrollbar-width:thin}
  .vw-track{animation:none}
  .vw-track>[data-wall-copy]{display:none}
  .vw-track>li{scroll-snap-align:start}
}
@media (min-width:768px){
  .vw-wall{gap:16px;-webkit-mask-image:linear-gradient(90deg,transparent,#000 64px,#000 calc(100% - 64px),transparent);mask-image:linear-gradient(90deg,transparent,#000 64px,#000 calc(100% - 64px),transparent)}
  .vw-track>li{width:300px;margin-right:16px}
  .vw-c{padding:16px 16px 14px}
  .vw-c-tx{font-size:13.5px}
}
`;
